import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Comments.css"; // Your CSS file

const Comments = () => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const baseURL = "https://khanehyeghtesad.com:8000"; // or your actual URL

  // 1. Fetch comments (which already have "verified" = "pending" or "verified").
  const fetchComments = async () => {
    const accessToken = localStorage.getItem("access");
    if (!accessToken) {
      navigate("/admin/login");
      return;
    }

    try {
      const response = await axios.get(`${baseURL}/api/comment/page/${page}/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      // IMPORTANT: Just use what the server sends you.
      // Do NOT override "verified" with "pending".
      // If your server returns "verified": "verified",
      // we keep it. If "verified": "pending", we keep it as is.
      // If you want to handle a "declined" state, you must ensure
      // your server also returns "verified": "declined" after you decline.
      setComments(response.data.comments);
      setTotalPages(response.data.total_pages);
    } catch (err) {
      setError("Failed to fetch comments.");
      console.error(
        "Fetch error:",
        err.response ? err.response.data : err.message
      );
    } finally {
      setLoading(false);
    }
  };

  // Fetch comments on mount or when page changes
  useEffect(() => {
    fetchComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  // 2. Handle verify or decline
  const handleVerification = async (commentId, action, slug)  => {
    const accessToken = localStorage.getItem("access");
    if (!accessToken) {
      navigate("/admin/login");
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}/api/comment/verify/`,
        {
          action, // "verify" or "decline"
          comment_id: commentId,
          slug: slug 
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Verification response:", response.data);

      // If server responds with 200 and e.g. { "message": "Comment verified." }
      // or { "message": "Comment declined." }, update local state
      if (response.status === 200 && response.data.message) {
        // Update the "verified" field in local state so the UI changes immediately
        setComments((prevComments) =>
          prevComments.map((comment) => {
            if (comment._id === commentId) {
              return {
                ...comment,
                // If verifying, set to "verified". If declining, set to "declined".
                // BUT remember: Your backend must also store and return "declined"
                // after a refresh. Otherwise, it will come back "pending".
                verified: action === "verify" ? "verified" : "declined",
              };
            }
            return comment;
          })
        );

        alert(response.data.message);
      } else {
        alert("Action did not succeed.");
        console.log("Non-successful verification response:", response.data);
      }
    } catch (err) {
      console.error(
        "Verification error details:",
        err.response ? err.response.data : err.message
      );
      alert("Failed to perform action.");
    }
  };

  // (Optional) Render replies if you have them
  const renderReplies = (replies) => {
    return replies.map((reply) => (
      <div key={reply._id} className="comment-reply">
        <p>
          <strong>{reply.name}</strong>: {reply.comment}
        </p>
        <small>
          {reply.jalali_full_date} - {reply.iran_time}
        </small>
      </div>
    ));
  };

  // Basic pagination
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  // Loading / error states
  if (loading) return <p>Loading comments...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="comments-section">
      <h2>مدیریت نظرات</h2>

      {comments.length > 0 ? (
        comments.map((comment) => (
          <div key={comment._id} className="comment-item">
            <p>
              <strong>{comment.name}</strong>: {comment.comment}
            </p>
            <small>
              {comment.jalali_full_date} - {comment.iran_time}
            </small>

            {/* Show the verified status from the server */}
            <div className="comment-status">
              <strong>وضعیت: </strong>
              {comment.verified === "verified"
                ? "تأیید شده"
                : comment.verified === "declined"
                ? "رد شده"
                : "در انتظار"}
            </div>

            <div className="comment-actions">
              <button
                onClick={() => handleVerification(comment._id, "verify", comment.slug)}
                disabled={comment.verified === "verified"}
              >
                تأیید
              </button>
              <button
                onClick={() => handleVerification(comment._id, "decline")}
                // You could also disable if "declined", or remove from list, etc.
                // disabled={comment.verified === "declined"}
              >
                رد
              </button>
            </div>

            {/* Render replies if any */}
            {comment.replies && renderReplies(comment.replies)}
          </div>
        ))
      ) : (
        <p>No comments available.</p>
      )}

      {/* Pagination */}
      <div className="pagination">
        <button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
          قبلی
        </button>
        <span>
          صفحه {page} از {totalPages}
        </span>
        <button
          onClick={() => handlePageChange(page + 1)}
          disabled={page === totalPages}
        >
          بعدی
        </button>
      </div>
    </div>
  );
};

export default Comments;
